"use client";
import React, { useState } from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import { useRouter } from "next/navigation";
import { EyeOpenIcon, EyeClosedIcon } from "@radix-ui/react-icons";
import Loader from "@/components/Common/Loader";
import Cookies from "js-cookie";
import { useAuth } from "@/contexts/AuthContext";
import Link from "next/link";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);
  const [loggingIn, setLoggingIn] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const { setToken, setUser } = useAuth();
  const router = useRouter();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoggingIn(true);
    setError(null);
    try {
      const response = await fetch("/api/authentication", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email,
          password,
          action: "login",
        }),
      });

      if (response.ok) {
        const data = await response.json();
        Cookies.set("yardstickAccessToken", data.token, {
          expires: 7,
          secure: true,
          sameSite: "strict",
        });
        localStorage.setItem("yardstickUser", JSON.stringify(data.user));
        setToken(data.token);
        setUser(data.user);
        toast.success("Login successful!");
        setTimeout(() => {
          router.push("/");
        }, 2000);
      } else {
        const errorData = await response.json();
        setError(errorData.message || "Login failed");
        toast.error(errorData.message || "Login failed");
      }
    } catch (err) {
      console.log(err);
      toast.error("An error occurred. Please try again.");
    } finally {
      setLoggingIn(false);
    }
  };

  return (
    <div className="mt-20 flex h-fit w-full flex-col items-center justify-center gap-10 p-20">
      <form
        onSubmit={handleSubmit}
        className="flex w-full max-w-md flex-col gap-6"
      >
        <div className="flex flex-col">
          <label htmlFor="email" className="mb-2">
            Email
          </label>
          <input
            type="email"
            id="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="rounded border border-gray-300 p-3"
            required
          />
        </div>

        <div className="flex flex-col">
          <label htmlFor="password" className="mb-2">
            Password
          </label>
          <div className="relative flex w-full flex-col">
            <input
              type={showPassword ? "text" : "password"}
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="rounded border border-gray-300 p-3"
              required
            />
            <span
              className="absolute right-2 top-1/2 -translate-y-1/2 transform cursor-pointer"
              onClick={() => setShowPassword((p) => !p)}
            >
              {showPassword ? <EyeOpenIcon /> : <EyeClosedIcon />}
            </span>
          </div>
        </div>

        {error && <p className="text-xs text-red-500">{error}</p>}

        <button
          type="submit"
          className="flex justify-center rounded-sm bg-primary px-8 py-4 text-base font-semibold text-white transition-all  duration-300 ease-in-out hover:bg-primary/80 dark:bg-primary1"
          disabled={loggingIn}
        >
          {loggingIn ? <Loader /> : "Sign In"}
        </button>

        <div className="mt-4 text-center">
          <p className="text-sm text-gray-600 dark:text-gray-400">
            Don&apos;t have an account?{" "}
            <Link href="/auth/register" className="text-primary hover:underline">
              Sign up
            </Link>
          </p>
        </div>
      </form>

      <ToastContainer />
    </div>
  );
};

export default Login;
